import {create} from 'zustand';

/**
 * 
 * showNotiModal(response2.data.resultMessage, {
        onConfirm: () => {
            handleClearAll();
        }
    });
 */

const useModalStore = create((set, get) => ({
    // Toast Modal
    toastState: false,
    setToastState: (boolean) => set({toastState: boolean}),
    text: '',
    setText: (text) => set({text: text}),

    // Notice Modal
    isModalOpen : false,
    setIsModalOpen: (boolean) => set({isModalOpen: boolean}),

    // modal message
    modalMessage: '',
    setModalMessage: (text) => set({modalMessage: text}),
    
    // My page Modal
    mypageModal: false,
    setMypageModal: (boolean) => set({mypageModal: boolean}),

    // 기관 검색 Modal
    emogSearchLayerOpen: false,
    setEmogSearchLayerOpen: (boolean) => set({emogSearchLayerOpen: boolean}),

    // Notice Modal state
    notiModal: false,
    setNotiModal: (boolean) => set({notiModal: boolean}),

    // Confirm Modal state
    confirmModal: false,
    setConfirmModal: (boolean) => set({confirmModal: boolean}),
    modalOptions: null,
    modalResolve: null,     // Promise resolve 함수(임시보관)

    // Prompt Modal state
    promptModal: false,
    promptValue: '',

    showNotiModal: (message, options) => {
        set({
            notiModal: true,
            confirmModal: false,
            promptModal: false,
            modalMessage: message,
            modalOptions: options ?? null,
        });
    },

    closeNotiModal: () => {
        const { modalOptions } = get();

        if (modalOptions?.onConfirm) {
            modalOptions.onConfirm();
        };

        set({
            notiModal: false,
            modalMessage: '',
            modalOptions: null,
        });
    },

  // 반환값이 Promise인 confirm - 호출자는 await로 결과(true/false)를 받는다.
    showConfirmModal: (message, options) => {
        return new Promise((resolve) => {
            // modalResolve에 resolve를 임시저장해 두고, 버튼 클릭 시 이 resolve를 호출
            set({
                confirmModal: true,
                notiModal: false,
                promptModal: false,
                modalMessage: message,
                modalOptions: options ?? null,
                modalResolve: resolve,
            });
        });
    },

  // 모달에서 '확인' 또는 '닫기'를 눌렀을 때 호출. result는 true(확인) 또는 false(취소)
    closeConfirmModal: (result = false) => {
        const resolver = get().modalResolve;
        if (typeof resolver === 'function') {
            try {
                resolver(result);
            } catch (error) {
                console.error('confirm 중 오류 발생:', error);
            }
        }
        set({
            confirmModal: false,
            modalMessage: '',
            modalOptions: null,
            modalResolve: null,
        });
    },

    // prompt 열기 (Promise 반환)
    showPromptModal: (message, options) => {
        return new Promise((resolve) => {
            set({
                promptModal: true,
                notiModal: false,
                confirmModal: false,
                modalMessage: message,
                modalOptions: options ?? null,
                modalResolve: resolve,
                promptValue: '', // 초기화
            });
        });
    },

    // input 값 변경
    setPromptValue: (value) => set({ promptValue: value }),

    // prompt 닫기
    closePromptModal: (result = false) => {
        const { modalResolve, promptValue } = get();

        if (typeof modalResolve === 'function') {
            try {
                modalResolve({
                    result,
                    value: promptValue
                });
            } catch (error) {
                console.error('prompt 중 오류 발생:', error);
            }
        }

        set({
            promptModal: false,
            modalMessage: '',
            modalOptions: null,
            modalResolve: null,
            promptValue: '',
        });
    },
}));

export default useModalStore;